import { auth } from '../config/firebase';

/** Firebase Auth instance (web: object, native: auth()). */
export function getFirebaseAuth(): {
  currentUser: { uid: string; reload: () => Promise<void>; delete: () => Promise<void>; updateProfile: (p: object) => Promise<void>; sendEmailVerification: () => Promise<void> } | null;
  onAuthStateChanged: (cb: (user: unknown) => void) => () => void;
  signOut: () => Promise<void>;
  GoogleAuthProvider?: { credential: (token: string, secret?: string) => unknown };
  AppleAuthProvider?: { credential: (token: string, nonce: string) => unknown };
  signInWithCredential?: (credential: unknown) => Promise<{ user: unknown }>;
} {
  return typeof auth === 'function' ? auth() : auth;
}

export function getCurrentAuthUser() {
  return getFirebaseAuth().currentUser ?? null;
}
